import { DRIVER_STATUS } from '@allocab/allocab-commons-shared-types';

import { assertNever } from './common';
import { t } from '../services/translation/translation';

export const getStatusText = (driverStatus: DRIVER_STATUS) => {
  switch (driverStatus) {
    case 'ACTIVATED':
      return t('driver-status.activated');
    case 'DEACTIVATED':
      return t('driver-status.deactivated');
    case 'SUBSCRIPTION':
      return t('driver-status.subscription');
    case 'SUBSCRIPTION_REVIEW':
      return t('driver-status.subscription-review');
    case 'SUSPENDED':
      return t('driver-status.suspended');
    case 'SUBSCRIPTION_CANCELLED':
      return t('driver-status.subscription-cancelled');
    default:
      assertNever(driverStatus, '[getStatusText] Step unknown');
      return t('common.unknown');
  }
};
